<template>
  <excel-export
    :data="items"
    :fields="excelFields"
    worksheet="Declaraciones"
    name="declaraciones_compliance.xlsx"
  />
</template>

<script>
import ExcelExport from '@/components/shared/ExcelExport.vue';
import { formatBoolean, formatDateTime } from '@/plugins/complianceScripts';

export default {
  name: 'StatementReportExcel',

  components: {
    ExcelExport
  },

  props: {
    items: Array
  },

  computed: {
    excelFields() {
        return {
          'Nombre declarante': {
            field: 'declarantName',
            width: 30,
          },
          'Correo declarante': {
            field: 'declarantMail',
            width: 30,
          },
          'Fecha de creación': {
            field: 'creationDate',
            callback: formatDateTime,
            width: 25,
          },
          'Respuestas': {
            field: 'answers',
            callback: value => value.map(answer => {
              let deepening = answer.questionDeepening ? ` - ${answer.answerTextDepth}` : '';
              return `${answer.questionName}: ${formatBoolean(answer.answerIsCorrect)}${deepening}`;

            } 
            ).join(", "),
            width: 60,
          }
        }
      }
  }
};
</script>